var map = {
	"./bg_logo_samson.svg": 2277,
	"./button-icon.svg": 128,
	"./marker.svg": 1602,
	"./play-icon.svg": 7083,
	"./register.svg": 9894,
	"./register_end.svg": 5315,
	"./register_start.svg": 2157
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5157;